import type { InventoryItem, Signature } from '../types'; // Removed Room, KeyEntry, PropertyDetails
import type { PropertyDetails } from '../components/PropertyDetailsForm'; // Or from '../types' if defined there

export const conditionDescriptions = {
  'Brand new': 'Still in wrapper or with new tags/labels attached.',
  'Good': 'Signs of slight wear, generally lightly worn.',
  'Fair': 'Signs of age, frayed, small light stains and marks, discolouration.',
  'Poor': 'Extensive signs of wear and tear, or stains, marks, tears, chips.',
  'Very Poor': 'Extensively damaged/faulty items, large stains, upholstery torn and/or dirty, pet odours/hairs.'
};

export const cleanlinessDescriptions = {
  'Professionally Cleaned': 'Everything immaculate with no dust and all appliances spotless. Carpets steam cleaned. Receipt provided for professional cleaning.',
  'Cleaned to professional standard': 'Cleaned to the same standard as above but without receipt provided.',
  'Good domestic standard': 'Flooring vacuumed and swept. Appliances cleaned and free of loose dirt. Some carbon deposits to appliances may be visible but no loose debris or grease to the touch. Some dust on tops of doors, cupboards. No loose hairs or soap deposits.',
  'Average Domestic standard': 'Domestic clean, but signs of dust to woodwork, kitchen units marked, appliances. Loose hairs, soap deposits visible.',
  'Poor domestic standard': 'Carpets need vacuum, all items dusty or dirty, kitchen and bathrooms require further cleaning.',
  'Not cleaned': 'No sign of cleaning.'
};

export const defaultRooms: { name: string; items: InventoryItem[] }[] = [
    {
      name: "Entrance / Hall",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Storage space", condition: "Good", notes: "", photos: [] }
      ]
    },
    {
      name: "Living Room",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Radiators / Heating", condition: "Good", notes: "", photos: [] },
        { category: "Built-in cupboards / shelves", condition: "Good", notes: "", photos: [] },
        { category: "Fires / Fire place", condition: "Good", notes: "", photos: [] }
      ]
    },
    {
      name: "Kitchen",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Built-in cupboards / shelves", condition: "Good", notes: "", photos: [] },
        { category: "Work Tops", condition: "Good", notes: "", photos: [] },
        { category: "Kitchen sink", condition: "Good", notes: "", photos: [] },
        { category: "Kitchen tap", condition: "Good", notes: "", photos: [] },
        { category: "Carbon monoxide monitor", condition: "Good", notes: "", photos: [] }
      ]
    },
    {
      name: "Bedroom 1",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Radiators / Heating", condition: "Good", notes: "", photos: [] },
        { category: "Built-in cupboards / shelves", condition: "Good", notes: "", photos: [] }
      ]
    },
    {
      name: "Bedroom 2",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Radiators / Heating", condition: "Good", notes: "", photos: [] },
        { category: "Built-in cupboards / shelves", condition: "Good", notes: "", photos: [] }
      ]
    },
    {
      name: "Bathroom/WC",
      items: [
        { category: "Flooring/Carpet", condition: "Good", notes: "", photos: [] },
        { category: "Walls", condition: "Good", notes: "", photos: [] },
        { category: "Ceiling", condition: "Good", notes: "", photos: [] },
        { category: "Doors", condition: "Good", notes: "", photos: [] },
        { category: "Windows", condition: "Good", notes: "", photos: [] },
        { category: "Window coverings", condition: "Good", notes: "", photos: [] },
        { category: "Electrical Fittings", condition: "Good", notes: "", photos: [] },
        { category: "Light bulbs and shades", condition: "Good", notes: "", photos: [] },
        { category: "Radiators / Heating", condition: "Good", notes: "", photos: [] },
        { category: "Extractor Fan", condition: "Good", notes: "", photos: [] },
        { category: "Sink and taps", condition: "Good", notes: "", photos: [] },
        { category: "Bath and shower taps", condition: "Good", notes: "", photos: [] },
        { category: "Toilet", condition: "Good", notes: "", photos: [] },
        { category: "Bidet", condition: "Good", notes: "", photos: [] }
      ]
    }
  ];

export const initialPropertyDetails: PropertyDetails = {
  address: '',
  reportType: 'checkIn' as 'checkIn' | 'checkOut' | 'midTerm',
  propertyDescription: '',
  inspectionDate: new Date().toISOString().split('T')[0],
  checkInDate: new Date().toISOString().split('T')[0],
  checkOutDate: new Date().toISOString().split('T')[0],
  inspectedBy: '',
  landlordName: '',
  tenantNames: [],
  propertyType: '',
  bedrooms: '',
  cleanliness: '',
  tenantsPresent: false
};

export const initialSignatures: Signature = {
    assessor: '',
    customer: '',
    date: new Date().toISOString().split('T')[0],
};

export const initialCertificates = {
    gas: { date: '', number: '', photos: [] as any[] },
    electrical: { date: '', number: '', photos: [] as any[] }
};

export const initialMeterReadings = {
    gas: { reading: '', location: '', supplier: '', serialNo: '', photos: [] as any[] },
    electricity: { reading: '', location: '', supplier: '', serialNo: '', photos: [] as any[] },
    water: { reading: '', location: '', supplier: '', serialNo: '', photos: [] as any[] }
};

interface KeyEntry { handedOver: string; type: string; quantity: string; photos?: any[]; } // Local definition if not imported
export const initialKeys: KeyEntry[] = [{ handedOver: '', type: '', quantity: '1', photos: [] }];

export const conditionOptions = [
    "Brand new",
    "Good",
    "Fair",
    "Poor",
    "Very Poor"
  ]; 